import styled from 'styled-components';

import Button from '@components/Button/next';

export const Container = styled.div`
  width: 100%;
  height: auto;
  position: relative;
`;

export const TourDetailContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.darkGrey};
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    background-color: ${({ theme }) => theme.palette.white};
  }
`;

export const SearchBarWrapper = styled.div`
  max-width: 1240px;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
    width: 100%;
  }
`;

export const TabWrapper = styled.div<{ visible: boolean; top: number }>`
  position: fixed;
  top: ${({ visible }) => (visible ? '0' : '-400px')};
  width: 100vw;
  height: 44px;
  background: ${({ theme }) => theme.palette.white};
  z-index: 99;
  transition: all 0.35s;
  box-shadow: 0 20px 20px 0 rgba(58, 58, 58, 0.2);

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border-top: 1px solid ${({ theme }) => theme.palette.lightsSilver};
    top: ${({ visible, top }) => (visible ? `${top - 2}px` : '-400px')};
  }
`;
export const Wrapper = styled.div`
  margin-left: 30px;
  margin-right: 30px;

  max-width: 1180px;
  z-index: 100;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: -10px 0 0 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: -6.8px;
  }
`;

export const ImagesWrapper = styled.div`
  position: relative;
  margin-bottom: -80px;
  z-index: 0;
  object-fit: contain;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  justify-content: center;
  padding: 40px 0 40px 0;
  margin-top: 30px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding-top: 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin: 0;
    padding-bottom: 0;
  }
`;

export const BreadcrumbWrapper = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-left: 20px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-left: 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 50px;
    align-items: center;
    padding: 15px;
    display: flex;
    margin-bottom: 0;
    max-width: auto;
  }
`;

export const TourTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  margin-top: 15px;
`;
export const TourTitleMobile = styled.h1`
  font-size: 18px;
  font-weight: bold;
  margin: 15px 15px -9px 15px;
`;
export const BreadcrumbWrapperListing = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding-left: 15px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 40px;
    align-items: center;
    padding: 15px;
    display: flex;
    margin-bottom: 0;
    max-width: auto;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

export const StyledButton = styled(Button)<{ cornerRadius: string }>`
  && {
    width: 50vw;
    height: 58px;
    font-size: 16px;
    font-weight: 400;
    border-radius: ${({ cornerRadius }) => cornerRadius};
  }
`;

export const SeoTextContainer = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin: 0;
    width: 100%;
  }
`;
export const NoContentWrapper = styled.div`
  height: 50px;
`;
export const ContainerTour = styled.div`
  height: 100%;
  padding-bottom: 50px;
  margin-left: -30px;
  margin-right: 30px;
`;
export const ContainerTourMobile = styled.div`
  height: 100%;
  margin-bottom: 10px;
  margin-left: -30px;
  margin-right: 30px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    background-color: ${({ theme }) => theme.palette.lynxWhite};
  }
`;
export const Title = styled.span<{ fontSize: number; margin?: number }>`
  font-size: ${({ fontSize }) => fontSize}px;
  font-weight: bold;
  margin-left: ${({ margin }) => (margin ? margin : 0)}px;
`;

export const TabsSubContainer = styled.div`
  width: 100vw;
  background-color: ${({ theme }) => theme.palette.white};
`;
